import en from './strings.en';

const ru = {
    send: 'Отправить',
    cancel: 'Отмена',
    placeholder: 'Напишите вопрос или предложение',
    thanks: 'Спасибо! Уже обрабатываем сообщение',
    requiredField: 'Необходимо заполнить',
};

export default { ru, en: { ...ru, ...en} };
